angular.module( 'acme.view.application.membership.offerings.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsModalsRemove = {
        name: 'application.membership.offerings.modals.remove',
        url: '/membership/offerings/modals/remove',
        views: {
          "main": {
            controller: 'MembershipOfferingsModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsModalsRemove);
});
